export default {
  TYPE: {
    TRANSACTION: {
      LABEL: 'Data da transação',
      KEY: 'transaction',
      VALUE: 'transação',
    },
    CREATED: { LABEL: 'Data de criação', KEY: 'created', VALUE: 'criação' },
    PAID: { LABEL: 'Data de pagamento', KEY: 'paid', VALUE: 'pagamento' },
    TRIP: { LABEL: 'Data da viagem', KEY: 'trip', VALUE: 'viagem' },
  },
};
